<div class="lead-details-page">
  <div class="card card-custom lead-details-shell details-page-shell">
    <div class="card-body">
        <div class="details_top">
          <div class="details-page-heading">
            <div class="details-page-heading__primary">
              <span class="details-page-heading__eyebrow">{{ 'LEAD_DETAILS' | translate }}</span>
            </div>
            <div class="details-page-heading__actions" *ngIf="doWhat.isAdmin || doWhat.canCreate || doWhat.canDelete">
              <button *ngIf="doWhat.isAdmin || doWhat.canCreate" type="button" class="orange-button" (click)="onEditLead()">{{ 'EDIT_LEAD' | translate }}</button>
              <button *ngIf="doWhat.isAdmin || doWhat.canDelete" type="button" class="red-button" (click)="onDeleteLead()">{{ 'DELETE' | translate }}</button>
            </div>
          </div>
          <h1 class="details-heading">
            <ng-container *ngIf="instance.isLastNameFirst; else firstLastHeading">
              {{ leadData?.lastName }} {{ leadData?.firstName }}
            </ng-container>
            <ng-template #firstLastHeading>
              {{ leadData?.firstName }} {{ leadData?.lastName }}
            </ng-template>
          </h1>
          <h3 class="details-subheading" *ngIf="leadData?.campaignName">{{ leadData?.campaignName }}</h3>
          <div class="row row-gap-4 d-flex align-items-stretch details-summary-grid">
            <div class="col-12 col-xl-6">
              <div class="card details-card">
                <h5 class="card-title">{{ 'LEAD_INFO' | translate }}:</h5>
                <div class="card-body">
                  <p>
                    <strong>{{ 'NAME' | translate }}:</strong>
                    <ng-container *ngIf="instance.isLastNameFirst; else firstLast">
                      {{ leadData?.lastName }} {{ leadData?.firstName }}
                    </ng-container>
                    <ng-template #firstLast>
                      {{ leadData?.firstName }} {{ leadData?.lastName }}
                    </ng-template>
                  </p>
                  <p><strong>{{ 'EMAIL' | translate }}:</strong> {{leadData?.email}}</p>
                  <p><strong>{{ 'PHONE' | translate }}:</strong> {{leadData?.phone}}</p>
                  <p><strong>{{ 'RECEIVED_AT' | translate }}:</strong> {{ formatDate(leadData.createdAt) }}</p>
                  <p><strong>{{ 'REFERRAL_SOURCE' | translate }}:</strong> {{leadData?.referralSource}}</p>
                  <p><strong>{{ 'REFERRAL_ID' | translate }}:</strong> {{leadData?.referralId}}</p>

                  <p><strong>{{ 'CONVERTED_TO_MEMBER' | translate }} </strong> <ui-switch [checked]="leadData.isMember" size="small" (change)="updateIsMemberState($event)"
                          defaultBoColor="#dfdfdf" color="#4ba6ef" [checkedLabel]="'COMMON.YES' | translate" [uncheckedLabel]="'COMMON.NO' | translate"
                          class="ms-1">
                      </ui-switch></p>
                  <p *ngIf="leadData.isMember"><strong>{{ 'MEMBER_SINCE' | translate }}:</strong> {{leadData.memberSince | P_AppDateFormat}}</p>
                </div>
              </div>
            </div>

            <div class="col-12 col-xl-6">
              <div class="card details-card">
                <h5 class="card-title">{{ 'CAMPAIGN_INFO' | translate }}:</h5>
                <div class="card-body">
                  <p><strong>{{ 'CAMPAIGN' | translate }}:</strong>
                    <a class="details-inline-link" [routerLink]="['/pages/campaign-details', leadData?.campaignId]"
                      [attr.title]="'VIEW_CAMPAIGN' | translate">
                      {{leadData?.campaignName}}
                    </a>
                  </p>
                  <p *ngIf="leadData?.crmName"><strong>{{ 'CRM' | translate }}:</strong> {{ leadData?.crmName }}</p>
                  <p *ngIf="leadData?.crmId"><strong>{{ 'CRM_ID' | translate }}:</strong> {{ leadData?.crmId }}</p>
                  <p *ngIf="leadData?.pageTitle"><strong>{{ 'LANDING_PAGE_TITLE' | translate }}:</strong> {{leadData?.pageTitle}}</p>
                  <p *ngIf="leadData?.pageUrl"><strong>{{ 'LANDING_PAGE_URL' | translate }}:</strong> {{leadData?.pageUrl}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dv-custom-navs">
          <ul ngbNav #nav="ngbNav" [(activeId)]="active" (activeIdChange)="onActiveTabChange($event)" class="nav-tabs details-nav-tabs">
            <li [ngbNavItem]="1" [class.rm-tab-active]="active === 1">
              <a ngbNavLink>
                <i-feather name="paperclip"></i-feather><label>{{ 'NOTES' | translate }}</label>
              </a>
              <ng-template ngbNavContent>
                <div class="details-tab-panel">
                  <div class="details-tab-panel__surface details-tab-surface details-tab-surface--notes">
                    <app-notes *ngIf="leadData?.id" [iCanDelete]="doWhat.isAdmin || (doWhat.roleOptions && doWhat.roleOptions.notes.canDelete)" [iCanWrite]="doWhat.isAdmin || (!isExternal) || doWhat.isAdmin || (doWhat.roleOptions && doWhat.roleOptions.notes.canWrite)" [iParentId]="leadData.id" [iType]="3"></app-notes>
                  </div>
                </div>
              </ng-template>
            </li>
          </ul>
          <div class="details-nav-outlet" [ngbNavOutlet]="nav"></div>
        </div>
    </div>
  </div>
</div>